<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        persistent
        max-width="900px"
    >
        <v-card>
            <v-card-title class="d-flex align-center">
                <span class="font-weight-medium">Insufficient stock</span>
                <v-spacer />
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-4">
                <p class="mb-4">
                    {{ description }}
                </p>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                    :mobile-breakpoint="0"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" rounded @click="close">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'NotAvailablePartNumbers',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
        description: {
            type: String,
            default:
                'The following components do not have enough available quantity to send this assembly work order for approval.',
        },
    },
    data: () => ({
        headers: [
            {
                text: 'Assembly Part Number',
                value: 'assemblyPartNumber',
                align: 'center',
            },
            {
                text: 'Part Number',
                value: 'partNumber',
                align: 'center',
            },
            {
                text: 'Available Qty',
                value: 'availableQty',
                align: 'center',
            },
            {
                text: 'Requested Qty',
                value: 'requiredQty',
                align: 'center',
            },
        ],
    }),
    methods: {
        close() {
            this.$emit('input', false)
        },
    },
}
</script>
